import { useCallback, useState } from 'react';

/**
 * Whether the chat covers the whole window.
 *
 * Deliberately not remembered, unlike whether the drawer is open. Full screen
 * is for giving one conversation the room it needs, not a way to use the app —
 * closing the chat ends that, and it opens beside the page again.
 */
export function useChatExpanded(): [boolean, () => void, () => void] {
  const [expanded, setExpanded] = useState(false);

  const toggle = useCallback(() => setExpanded((current) => !current), []);
  const collapse = useCallback(() => setExpanded(false), []);

  return [expanded, toggle, collapse];
}
